import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { getLensData, LensData } from "../../../services/lensService";
import { useAuth } from "../../auth/AuthContext";

const STALE_TIME_MINUTES = 5;
const SECONDS_PER_MINUTE = 60;
const MS_PER_SECOND = 1000;
const STALE_TIME_MS = STALE_TIME_MINUTES * SECONDS_PER_MINUTE * MS_PER_SECOND;

export const useLensData = (lensName: string): UseQueryResult<LensData> => {
  const { tenantId } = useAuth();

  return useQuery<LensData>({
    enabled: !!tenantId && !!lensName,
    queryKey: ["lens", tenantId, lensName],
    queryFn: () => getLensData(tenantId!, lensName),
    staleTime: STALE_TIME_MS
  });
};
